var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useContext, useEffect, useState, } from 'react';
import { useLegoland } from '../LegolandContext';
import { createAuthApiClient } from './authApiClient';
import { createUninitializedApiClient } from '../apiClientUtils';
var uninitializedClient = createUninitializedApiClient('Auth');
var AuthApiClientContext = createContext(uninitializedClient);
export var AuthApiClientConsumer = AuthApiClientContext.Consumer;
export function useAuthApiClient() {
    return useContext(AuthApiClientContext);
}
export var AuthApiClientProvider = function (_a) {
    var children = _a.children;
    var authApiUrl = useLegoland().authApiUrl;
    var _b = __read(useState(), 2), client = _b[0], setClient = _b[1];
    useEffect(function onMountEffect() {
        setClient(createAuthApiClient({ baseUrl: authApiUrl }));
    }, []);
    if (!client)
        return null;
    return (React.createElement(AuthApiClientContext.Provider, { value: client }, children));
};
//# sourceMappingURL=AuthApiClientContext.js.map